/* eslint-disable react/jsx-no-target-blank */
import { Lazy, Navigation } from 'swiper';
import Link from 'next/link';

import { SeturSmall } from '@assets/icons';
import IconLabelNext from '@components/ui/labels/icon/IconLabelNext';
import IconLabel from '@components/ui/labels/icon/IconLabel';
import { useDevice } from '@contexts/device';
import PlayVideoBadge from '@components/views/tour/components/video-badge';
import { useToggle } from '@hooks/common';
import VideoModal from '@components/views/tour/components/video-modal';
import Carousel, {
  SwiperSlide,
} from '@components/ui/cards/ListingItem/next/Carousel';
import { Int32StringTourListFeaturesViewModel } from '@api/v3';

import CloudinaryItemImage from '../CloudinaryItemImage';
import { Wrapper, SeturLogoWrapper, SeturVideoWrapper } from './styled';
export interface SliderImage {
  imageUrl: string;
  alt: string;
}
interface Props {
  images: SliderImage[];
  suggests?: boolean;
  secure?: boolean;
  fallBackImage?: string;
  seturExecutive?: boolean;
  href?: string;
  badge?: boolean;
  imageHeight?: number;
  name?: string;
  video?: string[];
  initialItem?: boolean;
  badgeAnimation?: Int32StringTourListFeaturesViewModel[];
  tour?: boolean;
}

const NextListingItemTourSlider = ({
  images,
  fallBackImage,
  seturExecutive,
  href,
  suggests,
  name,
  video,
  initialItem,
  badgeAnimation,
  tour,
}: Props) => {
  const { isDesktop } = useDevice();
  const [visibleVideoModal, toggleVideoModal] = useToggle(false);
  const sliderImages =
    images?.length > 0
      ? images
      : [
          {
            imageUrl: fallBackImage,
            alt: 'setur',
          },
        ];
  return (
    <Wrapper>
      <Carousel
        paginationShow={false}
        slider={Boolean(sliderImages.length > 1)}
        preloadImages={false}
        lazy={{
          enabled: true,
        }}
        modules={[Lazy, Navigation]}
      >
        {sliderImages?.map((item, index) => (
          <SwiperSlide key={index}>
            <Link
              href={href as string}
              target='_blank'
              title={name ?? ''}
              prefetch={false}
            >
              <CloudinaryItemImage
                url={item?.imageUrl ?? 'setur'}
                alt={name || 'setur'}
                key={item.imageUrl}
                fallBackImage={fallBackImage}
                width={isDesktop ? 230 : 343}
                height={230}
                borderRadius={8}
                lazyOnLoad={initialItem && index === 0 ? false : true}
              />
            </Link>
          </SwiperSlide>
        ))}
      </Carousel>
      {video && video?.length > 0 ? (
        <SeturVideoWrapper>
          <PlayVideoBadge onClick={() => toggleVideoModal()} />
        </SeturVideoWrapper>
      ) : null}

      <>
        {tour ? (
          <SeturLogoWrapper>
            <IconLabelNext
              badgeAnimation={badgeAnimation}
              icon={SeturSmall}
              backgroundColor='white'
              iconSize={14}
            />
          </SeturLogoWrapper>
        ) : (
          <>
            {seturExecutive && !suggests ? (
              <SeturLogoWrapper>
                <IconLabel
                  text='Sadece SETUR’da'
                  icon={SeturSmall}
                  backgroundColor='white'
                  iconSize={14}
                />
              </SeturLogoWrapper>
            ) : null}
            {seturExecutive && suggests ? (
              <SeturLogoWrapper>
                <IconLabel
                  description='Sadece SETUR’da'
                  text='SETUR Öneriyor'
                  icon={SeturSmall}
                  backgroundColor='white'
                  iconSize={14}
                />
              </SeturLogoWrapper>
            ) : null}
            {!seturExecutive && suggests ? (
              <SeturLogoWrapper>
                <IconLabel
                  text='SETUR Öneriyor'
                  icon={SeturSmall}
                  backgroundColor='white'
                  iconSize={14}
                />
              </SeturLogoWrapper>
            ) : null}
          </>
        )}
      </>

      {visibleVideoModal ? (
        <VideoModal
          title={name ?? ''}
          visible={visibleVideoModal}
          toggleModal={toggleVideoModal}
          videoURL={video?.[0]}
          isVideo={Boolean((video?.length ?? 0) > 0)}
          fallBackImage={sliderImages?.[0]?.imageUrl}
        />
      ) : null}
    </Wrapper>
  );
};

export default NextListingItemTourSlider;
